module.exports = __webpack_public_path__ + "static/media/img0.6c99d7a2.png";